export const SPECCED = 'SPECCED'
export const AUTOMATED = 'AUTOMATED'
